import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { logout, useApp} from '../store';
import { Loader } from './Loader';

export const RegisterFailure: React.FC = () => {
  const { t } = useTranslation();
  const { state, dispatch } = useApp();

  const handleLogout = () => {
      logout(dispatch);
  };

  if (state.loading) {
    return <Loader />;
  }

  return (
    <>
      <Trans i18nKey="registerAlreadyRegistered" />
      <button className="primary" onClick={handleLogout}>
        {t('registerCancel')}
      </button>
    </>
  );
};
